import React from 'react'
import { connect } from 'react-redux'
import { withFormik, Form, ErrorMessage } from 'formik'
import { TextField, Button, Grid, makeStyles } from '@material-ui/core'
import { lighten } from '@material-ui/core/styles';
import { attemptRegister } from '../../redux/actions/authActions'
import { string, object } from 'yup'
import { errorMsg } from '../../redux/actions/alertMessageActions'

const primaryColor = '#00AD9F'
const darkTextColor = '#727272'

const useStyles = makeStyles(theme => ({

    textField: {
        '& label': {
            color: darkTextColor,
        },
        '& label.Mui-focused': {
            color: primaryColor,
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: darkTextColor,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: primaryColor,
        },
    },
    button: {
        borderRadius: '30px',
        color: 'white',
        background: primaryColor,
        '&:hover, &:focus': {
            background: lighten(primaryColor, .5),
            border: 'none'
        },
        width: '12em'
    }
}))

const RegisterFormRaw = ({
    values,
    isSubmitting,
    handleChange,
}) => {
    const styles = useStyles()

    return (
        <Form>
            <Grid container spacing={4} className='text-center'>
                <Grid item xs={12}>
                    <TextField
                        label='نام و نام خانوادگی'
                        name='name'
                        onChange={handleChange}
                        value={values.name}
                        className={styles.textField}
                        fullWidth
                    />
                    <ErrorMessage name='name'>
                        {err => <article
                            className='text-danger mt-2 text-right'
                        >{err}</article>}
                    </ErrorMessage>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label='ایمیل'
                        name='email'
                        onChange={handleChange}
                        value={values.email}
                        className={styles.textField}
                        fullWidth
                    />
                    <ErrorMessage name='email'>
                        {err => <article
                            className='text-danger mt-2 text-right'
                        >{err}</article>}
                    </ErrorMessage>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label='رمز عبور'
                        name='password'
                        type='password'
                        placeholder='شامل حروف کوچک و بزرگ ، اعداد و علائم'
                        onChange={handleChange}
                        value={values.password}
                        className={styles.textField}
                        fullWidth
                    />
                    <ErrorMessage name='password'>
                        {err => <article
                            className='text-danger mt-2 text-right'
                        >{err}</article>}
                    </ErrorMessage>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label='تکرار رمز عبور'
                        name='confirm_password'
                        type='password'
                        onChange={handleChange}
                        value={values.confirm_password}
                        className={styles.textField}
                        fullWidth
                    />
                    <ErrorMessage name='confirm_password'>
                        {err => <article
                            className='text-danger mt-2 text-right'
                        >{err}</article>}
                    </ErrorMessage>
                </Grid>

                <Grid item xs={12} className='pt-2 mt-5 text-center'>
                    <Button
                        type='submit'
                        variant='contained'
                        className={styles.button}
                        disabled={isSubmitting}
                        fullWidth
                    >ثبت نام</Button>
                </Grid>
            </Grid>
        </Form>
    )
}

const RegisterForm = withFormik({
    mapPropsToValues: (props) => ({
        name: '',
        email: '',
        password: '',
        confirm_password: '',
    }),
    handleSubmit: (values, { props, setSubmitting, resetForm, setErrors }) => {
        setSubmitting(true)

        const { password, confirm_password } = values
        try {
            confirm_password === password
                ? props.dispatch(attemptRegister(values)) && resetForm(true)
                : props.dispatch(errorMsg('رمز ها یکی نیست')) && setSubmitting(false)
        } catch (error) {
            console.log(error)
            props.dispatch(errorMsg('بروز خطا در ثبت نام ، لطفا دوباره تلاش کنید'))
        }
    },
    validationSchema: object().shape({
        name: string().required('نام الزامی است'),
        email: string().email('فرمت ایمیل صحیح نیست').required('ایمیل الزامی است'),
        password: string().min(8, 'رمز عبور باید حداقل ۸ حرف باشد')
            .matches(
                /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\(\)\{\}\-\_])(?=.{8,})/,
                'رمز عبور باید شامل حروف کوچک ، حداقل یک حرف بزرگ ، حداقل یک عدد و حداقل یک علامت باشد'
            )
            .required('رمز عبور الزامی است'),
        confirm_password: string().required('تکرار رمز عبور الزامی است')
    })
})(RegisterFormRaw)

export default connect()(RegisterForm)